import { render, staticRenderFns } from "./ImageItemEdit.vue?vue&type=template&id=41b8af36"
import script from "./ImageItemEdit.vue?vue&type=script&lang=js"
export * from "./ImageItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports